import { getSlugFromPage } from '@eliadmin/core/src/utils/url-utils';

export const ROUTES_OVERRIDES = {
  // DELIVERY_PAYMENT: () => getSlugFromPage('delivery-payment'),
  // PRODUCT_RETURN: () => getSlugFromPage('product-return'),
  MY_DATA: () => getSlugFromPage('profile.data'),
  REFERENCES: () => getSlugFromPage('references'),
  COMPARISON: () => getSlugFromPage('product-comparison'),
  COLLECTIONS: () => getSlugFromPage('collections'),
};
